export const formatNumber = (num: number) => Number(num.toFixed(0));
